import * as Request from '@services/login';
import { history } from '@store/history';
import Button from 'ac-components/ac-btn';
import AcIcon from 'ac-components/ac-icon';
import Input from 'ac-components/ac-ipt';
import Alert from 'ac-components/alert';
import Modal from 'ac-components/modal';
import { LOGIN } from 'constants/url';
import { UseTranslationProps } from 'hooks/use-translation';
import { getState } from 'jumpstate';
import React, { useEffect, useRef, useState } from 'react';
import { UserInfo } from 'states/interface';
import styles from './styles.scss';
import { useCodeSentCountdown } from 'containers/ac-containers/login/login';
import { emailCodeSent } from '@services/login';
import { sendEvent } from '@core/track';
import { useTranslation } from 'hooks/use-translation';


let onClose: () => void = () => {
	throw new Error('reset-password close modal');
};

const noop = () => { };

let done = false;

// 关闭弹窗
const closeHandle = () => {
	onClose();
	if (done) { // 完成重置密码
		done = false;
		history.push(LOGIN); // 重新登录
	}
}

// 大写字母 小写字母 数字 特殊字符（四种里至少三种）
export const PasswordRegExp = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/

const SuccessImg = 'https://web-data.zmlearn.com/image/6hS6r1Qk8X8bNA2YBt8j8C/success.png';

type SendSmsBtnProps = {
	onClick?(): void;
	count?: number;
}
export function SendSmsBtn(props: SendSmsBtnProps) {
	const { onClick = noop, count } = props;
	const { transData } = useTranslation('login');
	return (
		<span
			onClick={onClick}
			className={`${styles.send_sms_btn} ${count === 0 ? styles.fire : ''}`}
		>
			{count ? `${transData.resendAgain}${count}s` : `${transData.resendCode}`}
		</span>
	)
}

enum Step {
	One,
	Two,
	Three,
}

type ResetMode = 'phone' | 'email'

function ResetPassword(props: { transition: UseTranslationProps }) {
	const [step, setStep] = useState<Step>(Step.One);
	const [psw, setPsw] = useState<string>('');
	const [pswTip, setPswTip] = useState<string>('');
	const [psw2, setPsw2] = useState<string>('');
	const [psw2Tip, setPsw2Tip] = useState<string>('');
	const [watch, setWatch] = useState<boolean>(false);
	const [sms, setSms] = useState<string>('');
	const [smsTip, setSmsTip] = useState<string>('');
	const [submitLoading, setSubmitLoading] = useState(false)
	const [codeSentLoading, setCodeSentLoading] = useState(false)
	const [alertTip, setAlertTip] = useState<string>('');
	const user: UserInfo = getState().app.user;
	const [resetMode, setRestMode] = useState<ResetMode>(user?.email ? 'email' : 'phone')
	const { timerCount, timerCountRef, countdownHandler } = useCodeSentCountdown(120)
	const { transData, t } = props.transition;
	useEffect(() => {
		if (!user) {
			history.push(LOGIN)
		}
		done = false;
	}, [])

	// 输入密码
	const onPswChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw(e.target.value.trim());
		setPswTip('');
	}
	// 二次输入密码
	const onPsw2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw2(e.target.value.trim());
		setPsw2Tip('');
	}
	// 查看密码
	const onWatchChange = () => {
		setWatch(!watch);
	}

	// 发送验证码
	const sendSms = async () => {
		sendEvent({ eventId: 'changepw_resendcode' })
		try {
			if (timerCount !== 0 || smsTip || codeSentLoading) return false
			setCodeSentLoading(true)
			setAlertTip('');
			const res = user.email ?
				await emailCodeSent({ email: user.email, scene: 3 }) :
				await Request.getResetPswCode({ areaCode: user.areaCode, mobile: user.mobile });
			if (res.code === Request.ResponseCode.OK && res.data) {
				countdownHandler();
				return true
			} else {
				setAlertTip(res.message);
				return false;
			}
		} finally {
			setCodeSentLoading(false)
		}
	}

	const onNextHandle = () => {
		let fire = true;
		if (!psw) {
			setPswTip(t('login.required'));
			fire = false;
		} else if (psw.length < 8) {
			setPswTip(t('login.pwsText'));
			fire = false;
		} else if (psw.length > 20) {
			setPswTip(t('login.pwsText1'));
			fire = false;
		}
		if (!psw2) {
			setPsw2Tip(t('login.required'));
			fire = false;
		}
		if (psw !== psw2) {
			setPsw2Tip(t('login.pwsText2'))
			fire = false;
		}
		if (!fire) return
		sendSms();
		setStep(Step.Two);
	}

	// 输入验证码
	const onSmsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSms(e.target.value);
		setSmsTip('');
		setAlertTip('');
	}

	// 提交
	const onSubmitHandle = async () => {
		sendEvent({ eventId: 'changepw_submitpw_save' })
		try {
			if (submitLoading) return
			if (!sms) {
				setSmsTip(t('login.required'));
				return
			}
			setSubmitLoading(true)
			const res = await Request.resetPassword(Object.assign({
				password: psw,
				validateCode: sms,
			}, ( user?.email ? { email: user?.email } : { areaCode: user.areaCode, mobile: user.mobile, } )))
			if (res.code === Request.ResponseCode.OK && res.data) {
				setStep(Step.Three);
				done = true;
			} else {
				setAlertTip(res.message);
			}
		} finally {
			setSubmitLoading(false)
		}
	}

	if (step === Step.One) {
		return (
			<div className={`${styles.reset_password} ${styles.step_1}`}>
				<div className={styles.title}>{transData.resetPwd}</div>
				<div className={styles.item}>
					<div className={styles.label}>
						{transData.password}
						<span className={styles.tip}>
							<AcIcon icon=' icon_info' />
							<div>{t('login.pwsText')}</div>
						</span>
					</div>
					<div className={styles.verify_tip}>{pswTip}</div>
					<Input
						type={watch ? 'text' : 'password'}
						placeholder={transData.password}
						onChange={onPswChange}
						style={{ height: 44 }}
						value={psw}
						suffix={(
							<AcIcon
								icon={watch ? 'icon_eyeopened' : 'icon_eyeclosed'}
								onClick={onWatchChange}
								className={styles.watch_icon}
								size={24}
							/>
						)}
					/>
				</div>
				<div className={styles.item}>
					<div className={styles.label}>{transData.reEnterPwd}</div>
					<div className={styles.verify_tip}>{psw2Tip}</div>
					<Input
						type={watch ? 'text' : 'password'}
						placeholder={transData.reEnterPwd}
						onChange={onPsw2Change}
						style={{ height: 44 }}
						value={psw2}
						suffix={(
							<AcIcon
								icon={watch ? 'icon_eyeopened' : 'icon_eyeclosed'}
								onClick={onWatchChange}
								className={styles.watch_icon}
								size={24}
							/>
						)}
					/>
				</div>
				<div className={styles.footer}>
					<Button
						size='medium'
						onClick={onNextHandle}
						disabled={Boolean(pswTip || psw2Tip)}
					>{transData.change}</Button>
				</div>
			</div>
		)
	}
	if (step === Step.Two) {
		return (
			<div className={`${styles.reset_password} ${styles.step_2}`}>
				<div className={styles.title}>{transData.resetPwd}</div>
				{alertTip && <Alert type='error'>{alertTip}</Alert>}
				<div className={styles.phone_info}>
					{
						resetMode === 'phone' ?
							`Check your phone for message with a verification code${user ? ' +' : ' '}${user.areaCode} ${user?.mobile}` :
							t('profile.sentEmail', { email: user?.email })
					}
				</div>
				<div className={styles.item}>
					<div className={styles.label}>Code</div>
					<div className={styles.verify_tip}>{smsTip}</div>
					<Input
						onChange={onSmsChange}
						placeholder={t('login.code')}
						type='number'
						style={{ 'height': 44 }}
						value={sms}
						suffix={<SendSmsBtn onClick={sendSms} count={timerCount} />}
					/>
				</div>
				<div className={styles.footer}>
					<Button
						size='medium'
						onClick={onSubmitHandle}
						disabled={!sms}
						loading={submitLoading}
					>{transData.confirm}</Button>
				</div>
			</div>
		)
	}
	if (step === Step.Three) {
		return (
			<div className={`${styles.reset_password} ${styles.step_3}`}>
				<div className={styles.title}>{transData.resetPwd}</div>
				<div className={styles.success_img}>
					<img src={SuccessImg} alt='' loading='lazy' />
				</div>
				<div className={styles.success}>
					<span>{transData.successMsg}</span>
					<span>{transData.successMsg1}</span>
				</div>
				<div className={styles.footer}>
					<Button size='medium' onClick={closeHandle}>{transData.ok}</Button>
				</div>
			</div>
		)
	}
	return null;
}

export default function resetPassword(transition: UseTranslationProps) {
	onClose = Modal.show({
		content: <ResetPassword transition={transition} />,
		size: 'mini',
		onClose() {
			closeHandle();
		},
	})
}
